<template>
  <PropertyOnboardingStep title="What are the requirements for your property? " :submit="submit">
    <RenterRequirementsForm ref="formRef" />
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { RenterRequirementsForm } from '@tallo/investor/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const formRef = ref<InstanceType<typeof RenterRequirementsForm>>();

async function submit() {
  await formRef.value?.save();
}
</script>
